'use client'

import { createContext } from 'react'

import { type PublicTenant } from '@rewardops/env'

type TenantProviderProps = {
  tenant: PublicTenant
  children: React.ReactNode
}

export const TenantContext = createContext<PublicTenant | null>(null)

export const TenantProvider: React.FC<TenantProviderProps> = ({
  tenant,
  children,
}) => {
  if (!tenant) {
    // You can handle an error here, if necessary
    throw new Error('Tenant not found')
  }

  return (
    <TenantContext.Provider value={tenant || null}>
      {children}
    </TenantContext.Provider>
  )
}
